import React, { useState, useEffect } from "react";
import { BtnAlternative } from "../../../Components/share/buttons/Btn";
import Card from "../../../Components/share/cards/Card";
import useFetch from "../../../Hooks/useFetch";

function Documents() {
    const [documents, setDocuments] = useState("");

    const getUserDocuments = useFetch({
        method: "GET",
        url: "CertificateService/11/bootcamp_certificates",
        noHeader: false,
        trigger: true,
        setter: setDocuments,
    });
    //Todo : id dynamic she

    return (
        <div>
            <h3 className=" text-purple text-[1.6rem] font-bold py-5">
                اطلاعات مدارک بوت کمپ
            </h3>
            <Card className="px-16 py-5 text-right font-bold text-[1.2rem] mt-32 flex justify-between">
                <span className="text-[1.6rem]">نام مدرک</span>
                <span className="text-[1.6rem]">نام گروه</span>
                {/* <span className="text-[1.6rem]">تاییدیه مدرک</span> */}
                <span className="text-[1.6rem]">دکمه دانلود مدرک</span>
            </Card>
            {documents?.results?.map((document) => {
                return (
                    <Card className="px-16 py-10 text-right flex justify-between font-bold text-[1.2rem] items-center mt-4">
                        <span className="text-[1.6rem]">
                            {document?.file_name}
                        </span>
                        <span className="text-[1.6rem]">
                            {document?.group_name}
                        </span>
                        {/* <span className="text-[1.6rem]">
                            {document?.is_confirmed ? (
                                <span className="text-green-500">
                                    تایید شده
                                </span>
                            ) : (
                                <span className="text-red-500">تایید نشده</span>
                            )}
                        </span> */}
                        <BtnAlternative
                            className=" py-5 px-6"
                            text="دانلود مدرک"
                            onClick={() => {
                                window.open(document?.file);
                            }}
                        />
                    </Card>
                );
            })}
        </div>
    );
}

export default Documents;
